import { j as e, a as n } from "../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { useState as f } from "react";
import { IonToggle as o, IonModal as u, IonButton as v } from "@ionic/react";
import I from "../../string-table.js";
import { Colors as r } from "../../1-foundations/Colors/Colors.js";
import { I as c } from "../../../Icon-IZV2yalv.js";
import "../../../FeatureFlagProvider-C_WBizLB.js";
import "../../../react-paginate-Lh5zQzpz.js";
import "../../organisms/LoadingInterstitial/LoadingInterstitial.js";
import "../../contexts/DesignSystemProvider/DesignSystemProvider.js";
import '../../../css/AliasBanner.css';const t = {
  "alias-banner-container": "_alias-banner-container_5hkkg_1",
  "alias-banner-label": "_alias-banner-label_5hkkg_18",
  "alias-truncate": "_alias-truncate_5hkkg_22"
};
function N(d) {
  const {
    email: m,
    isAdmin: h
  } = d, i = JSON.parse(localStorage.getItem("swing-view-as-admin") || "false"), [p, s] = f(!1), l = (a) => {
    const g = a.detail.checked;
    localStorage.setItem("swing-view-as-admin", JSON.stringify(g)), location.reload();
  };
  return /* @__PURE__ */ e("div", {
    role: "complementary",
    className: t["alias-banner-container"],
    children: /* @__PURE__ */ n("div", {
      css: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%"
      },
      children: [/* @__PURE__ */ n("div", {
        css: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-evenly"
        },
        children: [/* @__PURE__ */ e(c, {
          name: "Eye Glasses",
          color: r.white200
        }), /* @__PURE__ */ n("span", {
          className: `${t["alias-banner-label"]} ${t["alias-truncate"]}`,
          children: [I("LABEL_ALIASED"), ": ", m]
        })]
      }), h && /* @__PURE__ */ n("div", {
        css: {
          display: "flex",
          alignItems: "center",
          gap: "4px",
          cursor: "pointer"
        },
        children: [/* @__PURE__ */ e("div", {
          onClick: () => s(!0),
          children: /* @__PURE__ */ e(c, {
            name: "Help",
            color: r.white200
          })
        }), /* @__PURE__ */ e("span", {
          children: "View as admin"
        }), /* @__PURE__ */ e(o, {
          checked: i,
          onIonChange: (a) => l(a)
        }), /* @__PURE__ */ e(u, {
          isOpen: p,
          onIonModalDidDismiss: () => s(!1),
          children: /* @__PURE__ */ n("div", {
            css: {
              padding: 20
            },
            children: [/* @__PURE__ */ n("div", {
              css: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              },
              children: [/* @__PURE__ */ e("div", {
                children: "View As Admin"
              }), /* @__PURE__ */ e(o, {
                checked: i,
                onIonChange: (a) => l(a)
              })]
            }), /* @__PURE__ */ n("p", {
              children: ["As a superadmin, you have elevated privileges and can see certain things that a normal admin cannot. You are currently ", i ? "" : "not", " viewing this as a normal admin. To see exactly what the user sees, turn the above toggle to on."]
            }), /* @__PURE__ */ e(v, {
              onClick: () => s(!1),
              children: "Close"
            })]
          })
        })]
      })]
    })
  });
}
export {
  N as AliasBanner
};
